import { ChatHistoryIndex } from "@intelligems/ig-types/schemas/ai/chat-history";
import { aiApiClient } from "@src/api/ai-api";
import { aiExperimentAnalyticsV2Keys } from "@src/api/queryKeys";
import { EXPERIMENT_ANALYTICS_SUMMARY_CHAT_WORKFLOW_ID } from "@src/features/ai/components/usages/useAnalyticsSummaryV2";
import { useQuery } from "@tanstack/react-query";

interface UseGetExperimentAnalyticsChatHistoryV2Options {
  experienceId: string | null | undefined;
  enabled?: boolean;
}

const getExperimentAnalyticsChatHistoryV2 = async (
  experienceId: string
): Promise<ChatHistoryIndex[]> => {
  const response = await aiApiClient.get<ChatHistoryIndex[]>(
    "/chat-history/user/sessions",
    {
      params: {
        workflowId: EXPERIMENT_ANALYTICS_SUMMARY_CHAT_WORKFLOW_ID,
        metadataKey: "experienceId",
        metadataValue: experienceId,
      },
    }
  );
  return response.data ?? [];
};

export const useGetExperimentAnalyticsChatHistoryV2 = ({
  experienceId,
  enabled = true,
}: UseGetExperimentAnalyticsChatHistoryV2Options) => {
  return useQuery<ChatHistoryIndex[], Error>({
    queryKey: aiExperimentAnalyticsV2Keys.chatHistory(experienceId!),
    queryFn: async () => getExperimentAnalyticsChatHistoryV2(experienceId!),
    enabled: enabled && !!experienceId,
  });
};
